import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum BobcardRoles {
    /** Full workspace access; does not report to anyone. */
    "SystemAdmin" = "b2183880-ecfb-4941-a442-75b551940480",
    /** Full workspace access; does not report to anyone. */
    "SuperAdmin" = "31525601-b360-44a0-9828-80311a11ab85",
    /** Full workspace access; reports to Super Admin. */
    "Manager" = "767c926b-896a-443a-90e1-3e1fcedd0b11",
    /** Journeys/events only for leads assigned to this user; reports to Manager. */
    "Caller" = "57188655-fc82-44eb-95af-84fd43a8e359",
}

export const BOBCARD__USER__NAME__COLUMN_ID = "1fdc5ce1-a39f-428d-b8a6-0da0b2584624" as Uuid;

export const BOBCARD__USER__DISPLAY_NAME__COLUMN_ID = "fc9c89ab-0e0d-4b41-9f59-17f9702f8572" as Uuid;

export const BOBCARD__USER__EMAIL__COLUMN_ID = "081938b3-fe90-48ed-92ca-0de37b58268a" as Uuid;

export const BOBCARD__USER__CONTACT_NUMBER__COLUMN_ID = "62ae9c35-5bde-4f4a-89b4-476153032f6a" as Uuid;

export const BOBCARD__USER__DOB__COLUMN_ID = "b2fa9284-8791-474b-8818-a1abfccae0b4" as Uuid;

export const BOBCARD__USER__GENDER__COLUMN_ID = "934963c7-4538-44a3-8719-236beadbd63a" as Uuid;

export const BOBCARD__USER__STAFF_CODE__COLUMN_ID = "c1c13584-2a63-4f13-bb49-56951c3c840a" as Uuid;

export const BOBCARD__USER__PROFILE_IMAGE_URL__COLUMN_ID = "a6d090e6-c2cd-4cc2-861a-6786e3f87a68" as Uuid;

export const BOBCARD__USER__VERIFICATION_INVITED_AT__COLUMN_ID = "2a591ae6-9220-4e23-bbe0-7273729c7007" as Uuid;

export const BOBCARD__USER__VERIFICATION_INVITED_BY__COLUMN_ID = "0633fee5-f6cd-487f-87da-ea74e0f71aca" as Uuid;

export const BOBCARD__USER__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "0fa64dcb-252b-47ac-8781-dfc8662da77c" as Uuid;

export const BOBCARD__USER__VERIFICATION_PROCESSED_ON__COLUMN_ID = "b998fe99-bb4b-48ac-aee8-f34ddd1cea52" as Uuid;

export const BOBCARD__USER__VERIFICATION_PROCESSED_BY__COLUMN_ID = "55eeb1ce-9449-4e6e-a619-20042919906f" as Uuid;

export const BOBCARD__USER__VERIFICATION_REJECT_REASON__COLUMN_ID = "dac2b794-d2b6-4e53-8723-9dd8706a56ac" as Uuid;

export const BOBCARD__USER__COUNTRY__COLUMN_ID = "9adce702-c681-4964-9b79-4356ce134c23" as Uuid;
